module.exports = __webpack_public_path__ + "static/scen-5-ece862ff7da67340510f7afb26b9770e.svg";